import { Controller } from "@hotwired/stimulus"

// Says, as a handle is typed, whether it is anyone's yet: free, taken, held
// for someone, or held for you (when the email beside it is yours). Asked of
// the server a moment after the typing pauses, never on every keystroke.
export default class extends Controller {
  static targets = ["field", "email", "word"]
  static values = { url: String } // with NAME where the handle goes

  static PAUSE_MS = 350

  connect() {
    if (this.hasFieldTarget && this.fieldTarget.value.trim()) this.check()
  }

  check() {
    clearTimeout(this.timer)
    const name = this.hasFieldTarget ? this.fieldTarget.value.trim().replace(/^@/, "") : ""
    if (!name) return this.say(null)

    this.timer = setTimeout(() => this.ask(name), this.constructor.PAUSE_MS)
  }

  async ask(name) {
    const url = new URL(this.urlValue.replace("NAME", encodeURIComponent(name.toLowerCase())), location.href)
    const email = this.hasEmailTarget ? this.emailTarget.value.trim() : ""
    if (email) url.searchParams.set("email", email)

    this.asking?.abort()
    this.asking = new AbortController()
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: this.asking.signal })
      if (!response.ok) return
      const answer = await response.json()
      // The field may have moved on while we waited.
      if (this.fieldTarget.value.trim().replace(/^@/, "").toLowerCase() !== answer.handle) return
      this.say(answer)
    } catch (error) {
      if (error.name !== "AbortError") this.say(null)
    }
  }

  say(answer) {
    if (!this.hasWordTarget) return
    if (!answer) {
      this.wordTarget.hidden = true
      return
    }
    this.wordTarget.textContent = answer.word
    this.wordTarget.classList.toggle("handle-word-free", answer.available)
    this.wordTarget.hidden = false
  }

  disconnect() {
    clearTimeout(this.timer)
    this.asking?.abort()
  }
}
